/* tslint:disable */

/**
 *
 * Email validator directive imported from the angular 9.1.0 codebase and customised to invalidate emails
 * not containing the "dot" on the domain name
 *
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[emailDot][formControlName],[emailDot][formControl],[emailDot][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailDotValidatorDirective,
      multi: true
    }
  ]
})
export class EmailDotValidatorDirective implements Validator {
  private _enabled !: boolean;
  private _onChange !: () => void;

  /**
   * @description
   * Tracks changes to the emailDot attribute bound to this directive.
   */
  @Input()
  set emailDot(value: boolean|string) {
    this._enabled = value === '' || value === true || value === 'true';
    if (this._onChange) this._onChange();
  }

  /**
   * @description
   * Method that validates whether an email address is valid.
   * Returns the validation result if enabled, otherwise null.
   */
  validate(control: AbstractControl): ValidationErrors|null {
    return this._enabled ? this.emailDotValidator(control) : null;
  }

  emailDotValidator(control: AbstractControl): ValidationErrors|null {
    if (control.value == null || control.value.length === 0) {
      return null;  // don't validate empty values to allow optional controls
    }

    const EMAIL_REGEXP =
    /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return EMAIL_REGEXP.test(control.value) ? null : {'email': true};
  }

  /**
   * @description
   * Registers a callback function to call when the validator inputs change.
   *
   * @param fn The callback function
   */
  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
}
